<template>
	<div class="uk-position-relative">
		<div class="abacus__axis axis" :class="animate ? 'animate' : ''">
			<div class="bone bone--5" :class="bones[5].active ? 'active' : ''" @click="clickBone('5')"><img :src="$root.getThemeUrl() + 'img/bone.svg'" uk-svg alt=""></div>
			<div class="bone bone--1" :class="bones[1].active ? 'active' : ''" @click="clickBone('1')"><img :src="$root.getThemeUrl() + 'img/bone.svg'" uk-svg alt=""></div>
			<div class="bone bone--2" :class="bones[2].active ? 'active' : ''" @click="clickBone('2')"><img :src="$root.getThemeUrl() + 'img/bone.svg'" uk-svg alt=""></div>
			<div class="bone bone--3" :class="bones[3].active ? 'active' : ''" @click="clickBone('3')"><img :src="$root.getThemeUrl() + 'img/bone.svg'" uk-svg alt=""></div>
			<div class="bone bone--4" :class="bones[4].active ? 'active' : ''" @click="clickBone('4')"><img :src="$root.getThemeUrl() + 'img/bone.svg'" uk-svg alt=""></div>
		</div>
		<div class="axis__val" v-if="showNumbers">{{ value }}</div>
	</div>
</template>

<script>
  export default {
    name: "axis",
    data() {
      return {
        value: 0,
        bones: {
          1: {
            value: 1,
            active: false
          },
          2: {
            value: 1,
            active: false
          },
          3: {
            value: 1,
            active: false
          },
          4: {
            value: 1,
            active: false
          },
          5: {
            value: 5,
            active: false
          },
        }
      }
    },
    props: {
      extVal: '',
	    showNumbers: '',
	    canChange: '',
	    animate: ''
    },
    computed: {
      axisSum() {
        let sum = 0;
        let bones = this.bones;
        for (let key in bones) {
          if (bones[key].active) {
            sum = sum + bones[key].value;
          }
        }
        this.value = sum;
        return sum;
      },
    },
    watch: {
      'value': function () {
        this.$emit('bonesChanged');
      },
	    'extVal': function () {
        this.checkExtValue();
      }
    },
    mounted() {
      this.checkExtValue();
    },
    methods: {

      checkExtValue() {
        if (this.extVal) {
          this.value = this.extVal * 1;
        }
        this.axisSet();
      },
      axisSet() {
        let val = this.value;
        if (val >= 5) {
          this.setBonesState(val - 5, 5);
        } else {
          this.setBonesState(val);
        }
        this.value = val;
      },
      nullAxis() {
        for (let key in this.bones) {
          this.bones[key]['active'] = false;
        }
      },
      clickBone(val) {
        if(this.canChange){
          this.$emit('clickBone');
          this.changeBoneState(val);
        }
      },
      setBonesState(v1, v2) {
        this.nullAxis();
        if (v1 > 0) {
          this.bones[v1].active = true;
          let i = (v1 - 1);
          while (i > 0) {
            this.bones[i].active = true;
            i--;
          }
        }
        if (v2 > 0) {
          this.bones[v2].active = true;
        }
      },
      changeBoneState(val) {
        this.bones[val].active = !this.bones[val].active;
        //console.log(val);
        if (val < 5) {
          if (this.bones[val].active) {
            let i = (val - 1);
            while (i > 0) {
              this.bones[i].active = true;
              i--;
            }
          } else {
            let i = val;
            while (i < 5) {
              this.bones[i].active = false;
              i++;
            }
          }
        }
        this.$emit('bonesChanged');
      }
    },
	  updated() {

    }
  }
</script>